/// <amd-module name="Artifacts/Root/StringTools" />

/**
 * Compare two string case-insensitevely.
 */
export function ciEquals(string1: string, string2: string): boolean {
  return string1.localeCompare(string2, navigator.language, { sensitivity: "accent" }) === 0;
}
